import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CNConsultation } from '../models/cnconsultation';
import { CNDocumentFile } from '../models/cndocumentfile';
import { CNPatient } from '../models/cnpatient';
import { BecareService } from './becare.service';
import { UserConfigService } from './user-config.service';

export class Template {
  public templateid: string;
  public type: string;
  public template: string;
  public subject: string;
  public path: string;
  public id: string;
  public name: string;
  public linkedgroup: string;
  public linkedgroupname: string;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  templates: BehaviorSubject<Template[]> = new BehaviorSubject([]);

  constructor(private becare: BecareService, private userConfig: UserConfigService) {
    this.becare.call('/' + this.userConfig.user.language + '/document/templates/all')
      .subscribe(templates => {
        if (typeof templates.templates !== 'undefined' && Array.isArray(templates.templates)) {
          const allTemplates = [];
          templates.templates.forEach(template => {
            const newTemplate = new Template();
            Object.assign(newTemplate, template);
            allTemplates.push(newTemplate);
          });
          this.templates.next(allTemplates);
        }
      });
  }

  storeFile(file: File, patient: CNPatient, contact?: CNConsultation): Observable<CNDocumentFile> {
    return new Observable(observer => {
      let url = '/' + this.userConfig.user.language + '/document/patient/' + patient.id + '/upload';
      if (contact) {
        url = '/' + this.userConfig.user.language + '/document/contact/' + contact.id + '/upload';
      }
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.becare.call(url, [], formData, 'post', 'documentfile', true)
        .subscribe(documentFile => {
          console.log('upload result', documentFile);
          observer.next(documentFile);
        });
    });
  }
}
